import React, { useEffect, useState } from "react";
import {
  Button,
  Input,
  Modal,
  message,
  Table,
  Typography,
  Popconfirm,
  Tooltip,
  Empty,
} from "antd";
import { LinkOutlined } from "@ant-design/icons";
import CompanyServices from "../../services/CompanyServices";
import { translate } from "../../locale";
import SectionLoader from "../Loaders/SectionLoader";
import { TableHelper } from "../../helpers/TableHelper";

const { Search } = Input;

const { Title } = Typography;

const AssociateEntreprise = ({
  protocol,
  visible,
  onComplete,
  onCancel,
  protocolEntrepriseIds,
}) => {
  const [loading, setLoading] = useState(false);
  const [active, setActive] = useState(false);
  const [error, setError] = useState("");
  const [data, setData] = useState(null);
  const [filteredData, setFilteredData] = useState(null);
  const [tableParams, setTableParams] = useState({
    pagination: {
      current: 1,
      pageSize: 25,
      total: 0,
    },
  });
  const [total, setTotal] = useState(0);

  const columns = [
    {
      title: "",
      dataIndex: "actions",
      key: "actions",
      render: (_, record) => (
        <div className="flex space-x-4 justify-center">
          <Popconfirm
            title={
              <>
                {translate(`¿Asociar la empresa "${record.name}"`)}
                <br />
                {translate(`con el protocolo  "${protocol.name}"?`)}
              </>
            }
            okText="Si"
            cancelText="No"
            onConfirm={() => {
              associateEnterprise(record);
            }}
          >
            <Tooltip title={translate("Asociar")} color="blur">
              <Button
                type="text"
                icon={<LinkOutlined />}
                size="small"
                className="border-0"
              />
            </Tooltip>
          </Popconfirm>
        </div>
      ),
      width: 100,
    },
    {
      title: translate("Empresa"),
      dataIndex: "name",
      key: "name",
      sorter: { multiple: 1 },
    },
  ];

  useEffect(() => {
    if (visible !== null) {
      setActive(visible);
      if (visible === true && protocolEntrepriseIds !== null) {
        loadData();
      }
    }
  }, [visible, protocolEntrepriseIds, JSON.stringify(tableParams)]);

  const loadData = async () => {
    try {
      let data = {
        page_size: tableParams.pagination.pageSize,
        page_num: tableParams.pagination.current,
      };
      const sorter = TableHelper.sorter(tableParams);
      if (sorter !== null) {
        data = { ...data, order_by: sorter };
      }
      const response = await CompanyServices.getCompanies(data);
      if (response.status >= 200 && response.status < 300) {
        setData(
          response.data.enterprises.filter(
            (i) => !protocolEntrepriseIds.includes(i.id)
          )
        );
        setFilteredData(
          response.data.enterprises.filter(
            (i) => !protocolEntrepriseIds.includes(i.id)
          )
        );
        setTotal(response.data.total_pages * tableParams.pagination.pageSize);
      }
      setLoading(false);
    } catch (e) {
      console.log(e);
      setError(e.message);
      setLoading(false);
    }
  };

  const onSearch = (value) => {
    setFilteredData(
      data.filter((i) => i.name.toLowerCase().indexOf(value.toLowerCase()) > -1)
    );
  };

  const handleCancel = () => {
    setActive(false);
    if (onCancel) {
      onCancel();
    }
  };

  const associateEnterprise = async (enterprise) => {
    setLoading(true);
    setError("");
    try {
      const data = {
        protocol_id: parseInt(protocol.id),
        enterprises: [enterprise.id],
      };
      const res = await CompanyServices.asociateProtocol(data);

      if (
        res.status >= 200 &&
        res.status < 300 &&
        res.data &&
        res.data.protocol !== undefined
      ) {
        message.success(
          translate("La {0} se guardó exitosamente.", translate("empresa"))
        );
        if (onComplete) {
          onComplete(enterprise.id);
        }
      } else {
        message.error(
          translate("La {0} no pudo ser asociada.", translate("empresa"))
        );
      }
      setLoading(false);
    } catch (e) {
      console.log(e);
      setError(e.message);
      message.error(
        translate("La {0} no pudo ser guardada.", translate("empresa"))
      );
      setLoading(false);
    }
  };

  const handleTableChange = (pagination, filters, sorter) => {
    setTableParams({
      pagination,
      filters,
      sorter,
    });

    // `dataSource` is useless since `pageSize` changed
    if (pagination.pageSize !== tableParams.pagination?.pageSize) {
      setData([]);
    }
  };

  return (
    <Modal
      open={active}
      title={translate("Asociar empresa")}
      onOk={null}
      onCancel={handleCancel}
      footer={false}
    >
      <Title level={4}>{translate("Buscar empresa")}</Title>

      <Search
        placeholder={translate("Nombre de empresa")}
        allowClear
        size="large"
        name="email"
        onSearch={onSearch}
        loading={loading}
        className="max-w-sm mb-6"
        enterButton={translate("Buscar")}
      />

      <Table
        dataSource={filteredData}
        columns={columns}
        rowKey={(i) => i.id}
        locale={{
          emptyText: <Empty description={translate("No hay datos")} />,
          sortTitle: translate("Ordenar"),
          triggerDesc: translate("Ordenar (descendente)"),
          triggerAsc: translate("Ordenar (ascendente)"),
          cancelSort: translate("Cancelar orden"),
        }}
        pagination={{ ...tableParams.pagination, total: total }}
        onChange={handleTableChange}
      />
      {loading && <SectionLoader />}
    </Modal>
  );
};

export default AssociateEntreprise;
